module.exports = __webpack_public_path__ + "img/chevron-left-solid.439f4a8e.svg";